import React, { useState, useEffect } from "react";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import { Backdrop, Box, Grid, Paper } from "@material-ui/core";
import LibraryAddCheckIcon from "@material-ui/icons/LibraryAddCheck";
import CircularProgress from "@material-ui/core/CircularProgress";
import { AuthService } from "../../services/auth.service";
import styles from "../../styles/global-styles";
import { Role } from "../../_utils/roleEnum";
import { NotificationService } from "../../services/notification.service";
import { actions } from "../../redux/actions/alert";
import { connect } from "react-redux";
import { catalogArray } from "../../_utils/utils";
import { useHistory } from "react-router";

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  accountGrid: {
    paddingTop: "20px",
    paddingBottom: "10px",
  },
  iconAvatar: {
    marginLeft: 19,
    fontSize: "4em",
    color: "#ff5c33",
    backgroundColor: "#ffe0b3",
  },
  loginTitle: {
    color: " #262626",
    fontWeight: "bold",
  },
  button: {
    color: theme.palette.primary,
    backgroundColor: "#ffffff",
    fontSize: 13,
    marginBottom: "10px",
  },
  iconCard: {
    width: 52,
    height: 40,
    fontSize: 24,
    borderRadius: 4,
    margin: 10,
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  /** paper for Distributions **/
  paperLote: {
    width: 240,
    height: 70,
    padding: 5,
    borderRadius: 10,
    margin: "20px 26px",
    "& :hover": {
      cursor: "pointer",
    },
  },
  paper: {
    background: "#f2f2f2",
    width: 280,
    padding: 8,
    borderRadius: 10,
    margin: "20px 30px",
    "& :hover": {
      cursor: "pointer",
    },
  },
  description: {
    fontWeight: 400,
    marginLeft: 12,
  },
  subtitle: {
    fontSize: 17,
    paddingTop: 12,
    fontWeight: 600,
  },
  title: styles.title,
  backdrop: styles.backdrop,
  listItem: {
    position: "absolute",
    bottom: 10,
  },
  paperContainer: {
    width: "auto",
    maxHeight: "63vh",
    overflow: "scroll",
    marginBottom: 10,
  },
}));

const ListActions = ({ openDrawer, addAlert, detailAlert }) => {
  const classes = useStyles();
  const history = useHistory();

  const [showBackdrop, setShowBackDrop] = useState(false);
  const [userRole, setUserRole] = useState(null);
  const [loteDistribArray, setLoteDistribArray] = useState([]);

  useEffect(() => {
    const { roleId, id, siteId } = AuthService.currentUserValue;
    setUserRole(roleId);
    (async () => {
      if (roleId === Role.Seller) {
        try {
          const startDate = moment()
            .subtract(7, "days")
            .startOf("day")
            .format();
          const endDate = moment().endOf("day").format();
          const body = { siteId, userId: id, startDate, endDate };
          const {
            data,
          } = await NotificationService.getAllNotificationsWithParams(body);
          setLoteDistribArray(data);
          console.log("data", data);
        } catch (error) {
          addAlert({ showAlert: true });
          detailAlert({
            severity: "error",
            message: error.msgs,
          });
        }
      }
    })();
  }, []);

  const handleLogout = (e) => {
    setTimeout(() => AuthService.logout(), 2000);
    setShowBackDrop(true);
  };

  const handleCatalogueOption = (e, id) => {
    console.log("target", e.target.getAttribute("name"));
  };

  const handleDistribution = async (e, id) => {
    try {
      const body = { open: true };
      const { status } = await NotificationService.updateNotification(id, body);
      if (status === 201) {
        history.push("/dashboard/inventario/distribuciones/sucursal");
        openDrawer();
      }
    } catch (error) {
      console.log("error update", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: error.noAvailable ? "warning" : "error",
        message: error.noAvailable ? error.noAvailable : error.msgs,
      });
    }
  };

  const showOptionsByRole = () => {
    if (userRole === Role.Admin) {
      return <Box mt={3}> Acciones Rápidas </Box>;
    } else if (userRole === Role.Seller) {
      return <Box mt={3}> Distribuciones pendientes </Box>;
    } else {
      return "";
    }
  };

  const getDistributionsByLote = () => {
    return loteDistribArray.map((item) => {
      return (
        <Paper
          key={item.id}
          className={classes.paperLote}
          style={
            item.open ? { background: " #ffffff" } : { background: "#cdcdcd" }
          }
          variant="outlined"
          elevation={23}
          name="distribution"
          onClick={(e) => handleDistribution(e, item.id)}
        >
          <Grid container spacing={2} direction="row">
            <Grid item lg={4}>
              <LibraryAddCheckIcon
                style={
                  item.open
                    ? { backgroundColor: "#53c653" }
                    : { backgroundColor: "#3246D3" }
                }
                className={classes.iconCard}
                color="secondary"
              />
            </Grid>
            <Grid item lg={8}>
              <Typography
                className={classes.subtitle}
                style={item.open ? { color: "#040404" } : { color: "#1C2668" }}
                variant="subtitle1"
              >
                Lote {item.id}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      );
    });
  };

  const getCatalogueCards = () => {
    return catalogArray.map((item, i) => (
      <Paper
        key={i}
        className={classes.paper}
        variant="outlined"
        elevation={23}
        name={item.name}
        onClick={(e) => handleCatalogueOption(e)}
      >
        <Grid container spacing={2} direction="row">
          <Grid item lg={4}>
            {item.icon}
          </Grid>
          <Grid item lg={8}>
            <Typography className={classes.subtitle} variant="subtitle1">
              {item.labelName}
            </Typography>
          </Grid>
        </Grid>
      </Paper>
    ));
  };

  return (
    <div role="presentation">
      <Typography align="center" color="primary" variant="h5" component="h4">
        {showOptionsByRole()}
      </Typography>

      {userRole === Role.Seller && loteDistribArray.length > 0 && (
        <div className={classes.paperContainer}>{getDistributionsByLote()}</div>
      )}

      {userRole === Role.Admin && (
        <div className={classes.paperContainer}>{getCatalogueCards()}</div>
      )}

      <ListItem
        button
        color="secondary"
        className={classes.listItem}
        onClick={handleLogout}
      >
        <ListItemIcon>
          <ExitToAppIcon color="primary" />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography
              type="body"
              style={{ color: "#0b148", fontWeight: 700, fontSize: 18 }}
            >
              Cerrar sesión
            </Typography>
          }
        />
      </ListItem>

      <Backdrop className={classes.backdrop} open={showBackdrop}>
        <CircularProgress color="inherit" size={80} />
      </Backdrop>
    </div>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(ListActions);
